import { useState, useEffect } from 'react'

const useCurrentWeather = () => {
  const [currentWeather, setCurrentWeather] = useState('\xa0')

  useEffect(() => {
    let ignore = false

    const fetchWeather = async() => {
      try {
        const rawResult = await fetch(`https://api.openweathermap.org/data/2.5/onecall?lat=46.3523&lon=-124.0543&exclude=minutely,hourly,daily,alerts&appid=${process.env.GATSBY_OPEN_WEATHER_API_KEY}&units=imperial`)
        const jsonResult = await rawResult.json()
        if (!ignore) {
          setCurrentWeather(`${jsonResult.current?.temp.toFixed(0)}° / ${jsonResult.current?.weather[0]?.main}`)
        }
      }
      catch (error) {
        console.error(error)
      }
    }
    fetchWeather()

    return () => { ignore = true }
  }, [])

  return currentWeather
}

export default useCurrentWeather
